import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { makeImgResizerUrl } from '@jelly/utils';
import Media from 'react-media';
import { JsonLd } from 'react-schemaorg'; // Import Components

import { ArticleBody } from './ArticleBody';
import { AdsenseContext, Advertisement, ArticleSchema, ContentToolBar, DfpAdUnitSetup, Layout, SiteConfigContext } from '@jelly/components'; // Styled Components via Emotion

var ArticleContainer = _styled("div", {
  target: "e4964iu0",
  label: "ArticleContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "v2kfba",
  styles: "height:100%;width:100%;"
} : {
  name: "v2kfba",
  styles: "height:100%;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

/**
 * This is the Article Template Wrapper
 * Please check here for Article page variation requirements: https://bizdotcom.atlassian.net/wiki/spaces/BCS/pages/358252551/BDC+Article+Page+Variations
 */
export function Article(props) {
  var author = props.author,
      bestPicks = props.bestPicks,
      byLine = props.byLine,
      breadcrumbs = props.breadcrumbs,
      canonical = props.canonical,
      channels = props.channels,
      content = props.content,
      docType = props.docType,
      guid = props.guid,
      lastModified = props.lastModified,
      meta = props.meta,
      parsedContent = props.parsedContent,
      published = props.published,
      _props$relatedArticle = props.relatedArticles,
      relatedArticles = _props$relatedArticle === void 0 ? [] : _props$relatedArticle,
      relatedExperts = props.relatedExperts,
      relatedReviews = props.relatedReviews,
      relatedSponsoredArticles = props.relatedSponsoredArticles,
      resource = props.resource,
      slug = props.slug,
      _props$sponsorship = props.sponsorship,
      sponsorship = _props$sponsorship === void 0 ? {
    sponsorType: null
  } : _props$sponsorship,
      structuredData = props.structuredData,
      subtitle = props.subtitle,
      template = props.template,
      _props$thumbnail = props.thumbnail,
      thumbnail = _props$thumbnail === void 0 ? {} : _props$thumbnail,
      title = props.title,
      tocElements = props.tocElements,
      type = props.type;

  var _useContext = useContext(SiteConfigContext),
      _useContext$siteConst = _useContext.siteConstants,
      ALL_SPONSOR_TYPES = _useContext$siteConst.ALL_SPONSOR_TYPES,
      LONG_FORM = _useContext$siteConst.LONG_FORM;

  var resizedImage = makeImgResizerUrl({
    src: thumbnail.path,
    method: 'w',
    w: '700'
  });
  var isSponsoredArticle = sponsorship && (ALL_SPONSOR_TYPES === null || ALL_SPONSOR_TYPES === void 0 ? void 0 : ALL_SPONSOR_TYPES.includes(sponsorship === null || sponsorship === void 0 ? void 0 : sponsorship.sponsorType));

  var _useContext2 = useContext(AdsenseContext),
      adsenseMediaQuery = _useContext2.adsenseMediaQuery,
      hasAdsense = _useContext2.hasAdsense; // temporary: split related articles into two related sections for right rail and related end tile cards


  var relatedRightRailArticles = relatedArticles && relatedArticles.slice(0, 7);
  var relatedEndArticles = [];

  if (template === LONG_FORM) {
    relatedEndArticles = relatedArticles;
  } else {
    relatedEndArticles = relatedArticles && relatedArticles.length > 7 ? relatedArticles.slice(7) : null;
  }

  return /*#__PURE__*/React.createElement(ArticleContainer, null, /*#__PURE__*/React.createElement(Layout, {
    inverseLinkColors: true,
    meta: meta,
    hasAdDisclosure: true
  }, /*#__PURE__*/React.createElement(Helmet, {
    meta: [{
      name: 'twitter:image',
      content: resizedImage
    }, {
      property: 'og:image',
      content: thumbnail.path
    }]
  }), /*#__PURE__*/React.createElement(ContentToolBar, {
    breadcrumbs: breadcrumbs,
    canonical: canonical,
    title: title
  }), /*#__PURE__*/React.createElement(Advertisement, null), /*#__PURE__*/React.createElement(JsonLd, {
    item: ArticleSchema({
      author: author,
      canonical: canonical,
      content: content,
      lastModified: lastModified,
      published: published,
      title: title,
      thumbnail: thumbnail
    })
  }), structuredData && /*#__PURE__*/React.createElement(JsonLd, {
    item: structuredData
  }), /*#__PURE__*/React.createElement(ArticleBody, {
    author: author,
    byLine: byLine,
    canonical: canonical,
    channels: channels,
    bestPicks: bestPicks,
    docType: docType,
    heroCaption: thumbnail.caption,
    mainContent: content,
    lastModified: lastModified,
    parsedContent: parsedContent,
    published: published,
    resource: resource,
    relatedArticles: relatedRightRailArticles,
    relatedExperts: relatedExperts,
    relatedReviews: relatedReviews,
    relatedEndArticles: relatedEndArticles,
    relatedSponsoredArticles: relatedSponsoredArticles,
    sponsorship: sponsorship,
    subtitle: subtitle,
    title: title,
    template: template,
    thumbnail: thumbnail,
    tocElements: tocElements,
    type: type,
    slug: slug
  }), hasAdsense && /*#__PURE__*/React.createElement(Media, {
    query: adsenseMediaQuery,
    defaultMatches: false
  }, function (matches) {
    return (matches || isSponsoredArticle) && /*#__PURE__*/React.createElement(DfpAdUnitSetup, {
      channels: channels,
      docType: docType,
      guid: guid
    });
  })));
}